import { Button } from "@/components/Core/Button";
import { Input } from "@/components/Core/Input";
import RenderToast from "components/Core/RenderToast";
import { validateEmail } from "constant/regex";
import { useState } from "react";
import ModalSkeleton from "../ModalSkeleton";
import classes from "./forgotPasswordModal.module.css";

function ForgotPasswordModal({ show, setShow, onclick, isLoading }) {
  const [email, setEmail] = useState("");
  function onSubmit() {
    if (!email) {
      return RenderToast({ type: "error", message: "Email is required!" });
    }
    if (!validateEmail(email)) {
      return RenderToast({
        type: "error",
        message: "Please enter correct email!",
      });
    }
    onclick(email);
  }

  return (
    <ModalSkeleton
      show={show}
      setShow={setShow}
      header={`Forgot Password`}
      headerClass={classes.mainHeading}
      showCloseIcon={true}
    >
      <div className={classes.container}>
        <Input
          setter={setEmail}
          value={email}
          placeholder={"Enter email here"}
          label={"Email"}
        />
        <Button
          label={isLoading ? "Submiting..." : "Submit"}
          onClick={onSubmit}
          className={classes.btn}
          disabled={isLoading}
        />
      </div>
    </ModalSkeleton>
  );
}

export default ForgotPasswordModal;
